import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Loader from '../../../../../components/Loader';
import ReportBugButton from '../../../../../components/ReportBugButton';
import WOChooser from '../../../../../components/WOChooser/WOChooser';
import {
  selectCheckedItemContentID,
  selectSharedFSRoot
} from '../../../selectors';
import {
  getFileFrameRate,
  selectMemfisWoLKFS,
  STORAGE_MNG_LKFS_AUTO_CHOOSE_DESTINATION,
  STORAGE_MNG_LKFS_AUTO_UPDATE_AMB,
  STORAGE_MNG_LKFS_UPDATE_WO_MEMFIS,
} from "../../../actions";

const WOMemfisLayout = styled.div`
  min-height: 300px;
`;

function SelectWOMemfisView(props) {
  const {
    isWOMemfisLoading,
    onSubmitWO,
    rootID,
    contentID
  } = props;

  return <WOMemfisLayout>
    {isWOMemfisLoading &&
      <div>
        <Loader />
        <ReportBugButton isForModal className="loader-report-bug-btn" />
      </div>}
    <WOChooser
      onChoose={(value) => onSubmitWO(value, rootID, contentID)}
      fsRootID={rootID}
    />
  </WOMemfisLayout>;
}

function mapStateToProps(state) {
  return {
    rootID: selectSharedFSRoot(state),
    contentID: selectCheckedItemContentID(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmitWO: (value, rootID, contentID) => {
      getFileFrameRate(rootID, contentID, value, dispatch);
      selectMemfisWoLKFS(value, rootID, (response) => {
        dispatch({
          type: STORAGE_MNG_LKFS_AUTO_CHOOSE_DESTINATION,
          folder: {
            key: response.data.content.key,
            fsRootID: response.data.content.fsRootID,
          }
        });
        dispatch({
          type: STORAGE_MNG_LKFS_AUTO_UPDATE_AMB,
          numericAMB: response.autoAMB,
        });
      });
      dispatch({
        type: STORAGE_MNG_LKFS_UPDATE_WO_MEMFIS,
        value,
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectWOMemfisView);